<template>
  <AsideGabarit
    :title="$t('filters.collaborators', collaborators.length)"
    :baseline="`${collaborators.length}/${study?.collaborators.length} ${$t('filters.collaborators', collaborators.length)} ${$t('filters.inTotal')}`"
    :action="action"
  >
    <ToggleFilter
      :caption="$t('filters.collaboratorsLocation', collaborators.length)"
      :icon="'info'"
      :override-active="!disabled"
      :action="() => toggleFilterCollaborators()"
    />

    <div v-if="isDesktop || study.number_of_journeys <= 50000" class="filters-gabarit">
      <Draggable v-model="filtersData.filters" item-key="filterId" @end="saveOrder">
        <template #item="{ element }">
          <CheckBoxFilter
            :disabled="disabled"
            :filter-id="element.filterId"
            :title="element.translation"
            :filters="filtersData[element.filterId]"
            @save="saveFilterCategories"
          />
        </template>
      </Draggable>
    </div>

    <div v-else class="filters-disabled">
      {{ $t('filterRoomDisabled') }}
    </div>

    <button class="study-button reset" @click="resetFilters()">
      <i class="icon-refresh" />
      <span>{{ $t('filters.resetFilters') }}</span>
    </button>
  </AsideGabarit>
</template>

<script>
import { mapGetters } from 'vuex';
import AsideGabarit from './AsideGabarit';
import ToggleFilter from './ToggleFilter';
import CheckBoxFilter from './CheckBoxFilter';
import Draggable from 'vuedraggable';
import MixinFilters from './MixinFilters.vue';

export default {
  components: {
    AsideGabarit,
    ToggleFilter,
    CheckBoxFilter,
    Draggable,
  },

  mixins: [MixinFilters],
  props: ['action'],

  computed: {
    ...mapGetters({
      isDesktop: 'isDesktop',
      collaborators: 'collaborators',
      globalFilters: 'globalFilters',
    }),

    disabled() {
      return !this.globalFilters.collaborators;
    },
  },

  methods: {
    toggleFilterCollaborators() {
      this.$store.dispatch('updateGlobalFilters', {
        key: 'collaborators',
        value: !this.globalFilters.collaborators,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';

.filters-gabarit {
  padding: 0 10px 10px;
}

.filters-disabled {
  padding: 24px 10px 10px;
  color: #979797;
  font-size: 14px;
}

.reset {
  margin: 1rem auto;
  border: 2px solid #979797;
  color: #979797;
  display: flex;
  gap: 0.4rem;
  align-items: center;

  &:hover {
    background-color: #979797;
    color: white;
  }
}
</style>
